import { ResidentTransactionStatus } from '../types/Payments';

const TRANSACTION_STATUS_SET: ResidentTransactionStatus[] = [
    'pending',
    'processing',
    'succeeded',
    'failed',
    'skipped',
    'canceled',
    'refunded',
    'partially_refunded',
    'disputed',
];

const transactionStatusSetLookup = new Set(TRANSACTION_STATUS_SET);

export const TRANSACTION_STATUS_COLORS: Record<ResidentTransactionStatus, string> = {
    pending: '#C18400',
    processing: '#B54708',
    succeeded: '#137333',
    failed: '#B42318',
    skipped: '#5F6368',
    canceled: '#7A4B00',
    refunded: '#1264A3',
    partially_refunded: '#A16207',
    disputed: '#A63D40',
};

const TRANSACTION_STATUS_LABELS: Record<ResidentTransactionStatus, string> = {
    pending: 'Pending',
    processing: 'Processing',
    succeeded: 'Paid',
    failed: 'Payment Failed',
    skipped: 'Not Charged',
    canceled: 'Canceled',
    refunded: 'Refunded',
    partially_refunded: 'Partially Refunded',
    disputed: 'Disputed',
};

export const normalizeTransactionStatus = (status?: string | null): ResidentTransactionStatus => {
    const normalized = String(status || '').trim().toLowerCase();
    if (transactionStatusSetLookup.has(normalized as ResidentTransactionStatus)) {
        return normalized as ResidentTransactionStatus;
    }
    if (normalized === 'cancelled') {
        return 'canceled';
    }
    return 'pending';
};

export const formatTransactionStatusLabel = (status?: string | null): string => {
    const normalized = normalizeTransactionStatus(status);
    return TRANSACTION_STATUS_LABELS[normalized];
};
